import { useSelector } from "../../store";
import LoginModal from "../../components/Popups/LoginModal";
import RegisterModal from "../../components/Popups/RegisterModal";
import P2PBetCardModal from "../../components/Popups/P2PBetCardModal";
import P2PJoinModal from "../../components/Popups/P2PJoinModal";
import WalletModal from "../../components/Popups/WalletModal";
import DepositMetamaskModal from "../../components/Popups/DepositMetamaskModal";
import DepositGatewayModal from "../../components/Popups/DepositGatewayModal";
import JoinColorGameModal from "../../components/Popups/JoinColorGameModal";
import CongratulationModal from "../../components/Popups/CongratulationModal";
import BettingDetailModal from "../../components/Popups/BettingDetailModal";
import WingoHelpModal from "../../components/Popups/WingoHelpModal";
import AffiliateRuleModal from "../../components/Popups/AffiliateRuleModal";
import BonusClaimModal from "../../components/Popups/BonusClaimModal";
import AccountCloseModal from "../../components/Popups/AccountCloseConfirmModal";

const AuthLayout = () => {
    const { page } = useSelector((state) => state.menu);

    return (
        <>
            {page === 'login' && <LoginModal />}
            {page === 'register' && <RegisterModal />}
            {page === 'createP2p' && <P2PBetCardModal />}
            {page === 'joinP2p' && <P2PJoinModal />}
            {page === 'buycrypto' && <WalletModal />}
            {page === 'buycryptoMetamask' && <DepositMetamaskModal />}
            {page === 'buycryptoGateway' && <DepositGatewayModal />}
            {page === 'joinColorGame' && <JoinColorGameModal />}
            {page === 'congratulationModal' && <CongratulationModal />}
            {page === 'bettingDetailModal' && <BettingDetailModal />}
            {page === 'wingoHelp' && <WingoHelpModal />}
            {page === 'affiliateRule' && <AffiliateRuleModal />}
            {page === 'bonusClaim' && <BonusClaimModal />}
            {page === 'bonusClaim' && <BonusClaimModal />}
            {page === 'accountCloseConfirm' && <AccountCloseModal />}
            {/* {page === 'cashier' && <Cashier />}
            {page === 'register' && <Register />}
            {page === 'forgot' && <Forgot />}
            {page === 'reset-password' && <ResetPassword />}
            {page === 'bets' && <Bets />} */}
        </>
    );
};

export default AuthLayout;